"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const ro = require("redux-observable");
const list_1 = require("./list");
const region_1 = require("./region");
const userSettings_1 = require("./userSettings");
const projects_1 = require("./projects");
exports.allEpics = ro.combineEpics(list_1.fetchAdminUserList, region_1.getAllRegions, userSettings_1.updateMemberInfo, userSettings_1.resendAuthenticationCode, userSettings_1.resetPassword, userSettings_1.removeUser, userSettings_1.fetchCustomers, userSettings_1.updateUserCompany, userSettings_1.changePassword, userSettings_1.closeModal, projects_1.fetchProjects, userSettings_1.updateUserEmail, projects_1.fetchUser, projects_1.copyProjectPermissions, userSettings_1.fetchOrUpdateConsents);
//# sourceMappingURL=index.js.map